import { render, staticRenderFns } from "./Yinsiagreement.vue?vue&type=template&id=fa069b1a&scoped=true&"
import script from "./Yinsiagreement.vue?vue&type=script&lang=js&"
export * from "./Yinsiagreement.vue?vue&type=script&lang=js&"
import style0 from "./Yinsiagreement.vue?vue&type=style&index=0&id=fa069b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa069b1a",
  null
  
)

export default component.exports